import { useEffect } from 'react';
import { useAppDispatch, useAppSelector, adminActions } from '../app/store';
import { getStoredJwt, authenticateAdmin, storeJwt, clearJwt } from '../services/adminAuth';
import { connect, disconnect } from '../services/controlPlaneClient';

export function useAdminAuth() {
  const dispatch = useAppDispatch();
  const { authenticated, adminIdentity, connectionStatus } = useAppSelector(s => s.admin);

  useEffect(() => {
    // Check for existing JWT on mount
    // Restore admin JWT if previously authenticated
    const jwt = getStoredJwt();
    if (jwt) {
      dispatch(adminActions.setJwt(jwt));
      dispatch(adminActions.setAuthenticated(true));
    }
    // Always connect — SpacetimeDB token is managed internally via localStorage
    connect();

    return () => {
      disconnect();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Once connected with an identity, try to authenticate if not yet authenticated
  useEffect(() => {
    if (connectionStatus === 'connected' && adminIdentity && !authenticated) {
      const jwt = getStoredJwt();
      if (jwt) {
        dispatch(adminActions.setAuthenticated(true));
        return;
      }

      authenticateAdmin(adminIdentity)
        .then(({ jwt }) => {
          storeJwt(jwt);
          dispatch(adminActions.setJwt(jwt));
          dispatch(adminActions.setAuthenticated(true));
        })
        .catch(() => {
          clearJwt();
          dispatch(adminActions.setAuthenticated(false));
        });
    }
  }, [connectionStatus, adminIdentity, authenticated, dispatch]);

  return { authenticated, adminIdentity, connectionStatus };
}
